export * as collections from '@wix/auto_sdk_portfolio_collections/schemas';
export * as portfolioSettings from '@wix/auto_sdk_portfolio_portfolio-settings/schemas';
export * as projectItems from '@wix/auto_sdk_portfolio_project-items/schemas';
export * as projects from '@wix/auto_sdk_portfolio_projects/schemas';
export * as projectInCollections from '@wix/auto_sdk_portfolio_project-in-collections/schemas';
export * as syncedProject from '@wix/auto_sdk_portfolio_synced-project/schemas';
